import { render, staticRenderFns } from "./Galeri.vue?vue&type=template&id=c261cc74&"
import script from "./Galeri.vue?vue&type=script&lang=js&"
export * from "./Galeri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports